import { call, put, select } from "redux-saga/effects";
import { getInitDataVpoFailure } from "../actions";
import { getItemsRequest } from "../../spItems/api";
import { selectNextPage } from "../../spItems/selectors";
import { GetItemsRequestProps } from "src/modules/modules.type";
import { ListFieldsKeys } from "src/api/config";

export function* getDefaultSaga(payload: GetItemsRequestProps<ListFieldsKeys>) {
  try {
    if (payload) {
      if (payload.filters) {
        Object.keys(payload.filters).forEach(key => {
          const value = payload.filters![key];
          if (Array.isArray(value) && value.length > 50) {
            console.error('Большой массив', {
              listName: payload.listName,
              filterKey: key,
              arrayLength: value.length,
              array: value,
              stackTrace: new Error().stack
            });
          }
        });
      }

      const result: unknown = yield call(getItemsRequest, payload);
      return result;
    }
  } catch (error) {
    console.log(error);
  }
}
